'use strict';

var dataLayer = window.dataLayer || [];

module.exports = {
    // when user book an appointment : bookingFormSubmitted event
    appointmentBooked: function (datalayerValues) {
        var datalayerObject = {};
        datalayerObject.event = 'bookingFormSubmitted';
        datalayerObject.Name = datalayerValues.name;
        datalayerObject.mobileNumber = datalayerValues.mobileNumber;
        datalayerObject.emailHash = datalayerValues.emailHash;
        datalayerObject.typeOfAppointment = datalayerValues.typeOfAppointment || 'NA';
        datalayerObject.city = datalayerValues.city || 'NA';
        datalayerObject.storeName = datalayerValues.storeName || 'NA';
        var dateTime = (datalayerValues.date || '') + ' ' + (datalayerValues.time || '');
        datalayerObject.dateTime = dateTime;
        dataLayer.push(datalayerObject);
    },
    sendUserDetails: function (gtmdata) {
        var datalayerObject = {};
        datalayerObject.event = 'appointment_next_step';
        datalayerObject.Name = gtmdata.name;
        datalayerObject.mobileNumber = gtmdata.mobileNumber;
        datalayerObject.emailHash = gtmdata.emailHash;
        dataLayer.push(datalayerObject);
    },
    // when user verifies the captcha : otpVerified event
    captchaVerified: function () {
        var datalayerObject = {};
        datalayerObject.event = 'otpVerified';
        dataLayer.push(datalayerObject);
    }
};
